<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="43"
    viewBox="0 0 66 43"
  >
    <path
      :fill="fill"
      d="M3.617 0C2.066 0 .75 1.316.75 2.867v37.266C.75 41.684 2.066 43 3.617 43h58.766c1.551 0 2.867-1.316 2.867-2.867V2.867C65.25 1.316 63.934 0 62.383 0H3.617zm4.255 4.3h50.256L33 25.844 7.872 4.3zM5.05 7.503L20.167 20.47 5.05 35.587V7.503zm55.9 0v28.084L45.833 20.47 60.95 7.503zM23.437 23.292l8.174 6.987c.8.677 1.977.677 2.777 0l8.174-6.987L57.971 38.7H8.028l15.409-15.408z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MailIcon',
  props: {
    color: {
      type: String,
      required: true
    }
  },
  computed: {
    fill () {
      if (this.color === 'gold') {
        return '#eeaf00'
      }
      if (this.$vuetify.theme.themes.light[this.color]) {
        return this.$vuetify.theme.themes.light[this.color]
      }
      return '#333'
    }
  }
}
</script>
